import React from 'react';
import '../faqs/faqWrapp.css';

function FaqItem({ question, answer, isOpen, onToggle }) {
  return (
    <div className="faq-col1">
      <h3
        onClick={onToggle}
        className={isOpen ? 'active' : ''}
        style={{ cursor: 'pointer' }}
      >
        {question}
      </h3>

      <div className={`content ${isOpen ? 'open' : ''}`}>
      <p>{answer}</p>
    </div>
    </div>
  );
}

export default FaqItem;
